// extracted by mini-css-extract-plugin
module.exports = {"single-site":"SingleSiteTitle_single-site__z7s0v"};